import React, { useState } from 'react';
import { mockBankTransactions, formatCurrency } from '../../../services/mockData';

const BankbookReport = () => {
  const [fromDate, setFromDate] = useState('01-04-2025');
  const [toDate, setToDate] = useState('31-03-2026');
  const [ledger] = useState('BANK OF INDIA-0002052363252111');

  const totalDr = mockBankTransactions.reduce((s, t) => s + t.dr, 0);
  const totalCr = mockBankTransactions.reduce((s, t) => s + t.cr, 0);

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="breadcrumb">Bank &amp; Cash Reports <span>/ Bankbook Report</span></div>
        <h2>Bank Book Report</h2>
      </div>

      {/* Filter */}
      <div className="filter-bar">
        <div className="form-group">
          <label>Select Ledger</label>
          <select className="form-control" defaultValue={ledger}>
            <option>{ledger}</option>
          </select>
        </div>
        <div className="form-group">
          <label>Date Type</label>
          <select className="form-control">
            <option>Posted Date</option>
            <option>Clear Date</option>
          </select>
        </div>
        <div className="form-group">
          <label>From Date</label>
          <input type="text" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} />
        </div>
        <div className="form-group">
          <label>To Date</label>
          <input type="text" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} />
        </div>
        <div className="form-group" style={{ justifyContent: 'flex-end' }}>
          <button className="btn btn-primary">🔍 Search</button>
        </div>
        <div className="form-group" style={{ justifyContent: 'flex-end' }}>
          <div className="btn-group">
            <button className="btn btn-warning btn-sm">🖨️ Print / Save as PDF</button>
            <button className="btn btn-success btn-sm">📊 Export To Excel</button>
          </div>
        </div>
      </div>

      {/* Report */}
      <div className="card">
        <div className="report-header">
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023</p>
          <p>dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>
            {ledger} for Financial Year: 2025-2026<br />
            On Dated: 01-02-2026 For Period: <b>01-04-2025 to 31-03-2026</b>
          </p>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Posted Dt</th>
                <th>Particulars</th>
                <th>Type / No</th>
                <th>ChqNo</th>
                <th>ChqDate</th>
                <th className="amount">Dr</th>
                <th className="amount">Cr</th>
                <th className="amount">Balance</th>
              </tr>
            </thead>
            <tbody>
              {mockBankTransactions.map((t, i) => (
                <tr key={i}>
                  <td style={{ whiteSpace: 'nowrap' }}>{t.postedDate}</td>
                  <td>
                    <div>{t.particulars.split('\n')[0]}</div>
                    {t.particulars.split('\n')[1] && (
                      <div style={{ fontSize: '11px', color: '#718096' }}>{t.particulars.split('\n')[1]}</div>
                    )}
                    {t.mode && <span className="badge badge-primary" style={{ marginTop: '2px' }}>{t.mode}</span>}
                  </td>
                  <td>{t.type}</td>
                  <td>{t.voucherNo}</td>
                  <td>{t.chqDate}</td>
                  <td className="amount dr">{t.dr > 0 ? formatCurrency(t.dr) : ''}</td>
                  <td className="amount cr">{t.cr > 0 ? formatCurrency(t.cr) : ''}</td>
                  <td className="amount" style={{ fontWeight: '700' }}>
                    {formatCurrency(t.balance)} <span className={t.balType === 'CR' ? 'cr' : 'dr'} style={{ fontSize: '10px' }}>{t.balType}</span>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={5} style={{ textAlign: 'right', fontWeight: '800' }}>Total</td>
                <td className="amount dr">{formatCurrency(totalDr)}</td>
                <td className="amount cr">{formatCurrency(totalCr)}</td>
                <td className="amount">
                  {formatCurrency(mockBankTransactions[mockBankTransactions.length - 1]?.balance)} <span className="cr" style={{ fontSize: '10px' }}>CR</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BankbookReport;
